import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Link } from 'react-router-dom';
const HTTP_PROTOCOL = 'http';
const isNativeLink = (url) => {
    let parsedURL;
    if (url === undefined) {
        return true;
    }
    if (url.startsWith('mailto:') || url.startsWith('tel:') || url.startsWith('#')) {
        return true;
    }
    try {
        parsedURL = new URL(url);
    }
    catch (e) {
        return false;
    }
    return parsedURL.protocol.startsWith(HTTP_PROTOCOL);
};
export const genericComponents = {
    LINK: React.forwardRef(({ children, className, id, onClick, target, titleLink: title, url, disabled = undefined, onPointerEnter, onPointerLeave, onPointerDown, onPointerUp, ...props }, ref) => {
        const commonProps = {
            className,
            id,
            onClick,
            target,
            title,
            onPointerEnter,
            onPointerLeave,
            onPointerDown,
            onPointerUp,
            'aria-disabled': props['aria-disabled'],
            'aria-label': props['aria-label'],
            'aria-labelledby': props['aria-labelledby'],
            'data-testid': props['data-testid'],
            'role': props['role'],
        };
        return isNativeLink(url) ? (_jsx("a", { ...commonProps, ref: ref, "data-disabled": disabled, href: url, children: children })) : (_jsx(Link, { ...commonProps, ref: ref, "data-disabled": disabled, to: url, children: children }));
    }),
};
genericComponents.LINK.displayName = 'LINK';
//# sourceMappingURL=genericComponents.js.map